export function stripEmoji(text) {
    if (!text) return text;
    return text
        .replace(/\p{Extended_Pictographic}/gu, '')
        .replace(/[\u200B-\u200D\u2060\uFE0E\uFE0F\uFEFF]/g, '')
        .replace(/\s+/g, ' ')
        .trim();
}
